import { api } from "../utils/api";

const list = async (type, classId) => {
  const res = await api.get("/ClassDiaryV1/menus", {
    params: {
      type,
      ...(classId ? { classId } : {})
    }
  });
  return Array.isArray(res.data) ? res.data : [];
};

const MenuService = {
  list
};

export default MenuService;
